import { uuid } from 'uuidv4'
import {
  SET_ATTENDANT_STATUS_FILTER_VALUE,
  CREATE_SUITES_STAFF_REQUESTED,
  CREATE_SUITES_STAFF_SUCCEEDED,
  CREATE_SUITES_STAFF_FAILED,
  GET_SUITES_STAFF_REQUESTED,
  GET_SUITES_STAFF_SUCCEEDED,
  GET_SUITES_STAFF_FAILED,
  REMOVE_SUITES_STAFF_REQUESTED,
  REMOVE_SUITES_STAFF_SUCCEEDED,
  REMOVE_SUITES_STAFF_FAILED,
  UPDATE_TOGGLE,
  UPDATE_SUITES_STAFF_REQUESTED,
  UPDATE_SUITES_STAFF_SUCCEEDED,
  UPDATE_SUITES_STAFF_FAILED,
  SEARCH_SUITES_STAFF_SUCCEEDED
} from './constants'
import api from '../../utils/api'
import { createAttendantSetting } from '../../store/AppDeviceConfiguration/actions'
import { createEmployeeRole } from '../EmployeeRole/actions'

export const createSuitesStaffRequested = () => ({
  type: CREATE_SUITES_STAFF_REQUESTED
})
export const createSuitesStaffSucceeded = (payload) => ({
  type: CREATE_SUITES_STAFF_SUCCEEDED,
  payload
})
export const createSuitesStaffFailed = () => ({
  type: CREATE_SUITES_STAFF_FAILED
})

export const getSuitesStaffRequested = () => ({
  type: GET_SUITES_STAFF_REQUESTED
})

export const getSuitesStaffSucceeded = (payload) => ({
  type: GET_SUITES_STAFF_SUCCEEDED,
  payload
})

export const getSuitesStaffFailed = () => ({
  type: GET_SUITES_STAFF_FAILED
})

export const removeSuitesStaffRequested = () => ({
  type: REMOVE_SUITES_STAFF_REQUESTED,
})
export const removeSuitesStaffSucceeded = (uuid) => ({
  type: REMOVE_SUITES_STAFF_SUCCEEDED,
  payload: uuid
})
export const removeSuitesStaffFailed = () => ({
  type: REMOVE_SUITES_STAFF_FAILED,
})

export const updateToggle = (key, value) => ({
  type: UPDATE_TOGGLE,
  payload: { key, value }
})

export const updateSuitesStaffRequested = () => ({
  type: UPDATE_SUITES_STAFF_REQUESTED
})

export const updateSuitesStaffSucceeded = (payload) => ({
  type: UPDATE_SUITES_STAFF_SUCCEEDED,
  payload
})

export const updateSuitesStaffFailed = () => ({
  type: UPDATE_SUITES_STAFF_FAILED
})

export const createSuitesStaff = (venueUuid, attendantAndAttendantSettingParams, employeeRole) => dispatch => {
  const { attendantParams, attendantSettingParams } = attendantAndAttendantSettingParams
  dispatch(createSuitesStaffRequested())

  return api
    .createAttendant(venueUuid, attendantParams)
    .then(response => {
      dispatch(createSuitesStaffSucceeded(response.data.attendants))
      dispatch(createAttendantSetting(venueUuid, attendantSettingParams))
      const employeeUuid = response?.data?.attendants?.[0]?.uuid
      const employeeRoleParams = { role: employeeRole, employeeUuid, uuid: uuid() }
      dispatch(createEmployeeRole(employeeRoleParams))
    })
    .catch(() => dispatch(createSuitesStaffFailed()))
}

export const loadSuitesStaff = venueUuid => dispatch => {
  dispatch(getSuitesStaffRequested())

  return api
    .fetchAttendants(venueUuid)
    .then(response => dispatch(getSuitesStaffSucceeded(response.data.attendants)))
    .catch(() => dispatch(getSuitesStaffFailed()))
}

export const updateSuitesStaff = (params) => dispatch => {
  dispatch(updateSuitesStaffRequested())

  return api
    .updateAttendant(params)
    .then(response => dispatch(updateSuitesStaffSucceeded(response.data.attendants)))
    .catch(() => dispatch(updateSuitesStaffFailed()))

}

export const removeSuitesStaff = (uuid) => dispatch => {
  dispatch(removeSuitesStaffRequested())

  return api
    .removeAttendant(uuid)
    .then(response => dispatch(removeSuitesStaffSucceeded(uuid)))
    .catch(() => dispatch(removeSuitesStaffFailed()))
}

export const searchSuitesStaff = (payload) => ({
  type: SEARCH_SUITES_STAFF_SUCCEEDED,
  payload
})

export const setAttendantStatusFilterValue = (payload) => ({
  type: SET_ATTENDANT_STATUS_FILTER_VALUE,
  payload
})
